import PropTypes from 'prop-types';
import React from 'react';
import {GuidedSearch} from 'src/shared/components/GuidedSearch';
import {Link} from 'src/shared/components/Link';
import {
  breadcrumb as breadcrumbStyle,
  breadcrumbs as breadcrumbsStyle,
  subnav,
} from 'src/shared/components/SubNav/style.module.scss';
import {
  light,
  link,
} from 'src/styles/modules/links.module.scss';

export const SubNav = ({breadcrumbs}) => (
  <section className={subnav}>
    <div>
      <nav className={breadcrumbsStyle}>
        {
          breadcrumbs.map(breadcrumb => (
            <Link key={`${breadcrumb.href}`} className={`${breadcrumbStyle} ${link} ${light}`} {...breadcrumb} />
          ))
        }
      </nav>
      <GuidedSearch
        placeholder="Search Support"
        includeArticles={true}
        compact={true}
      />
    </div>
  </section>
);

SubNav.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string,
  })),
};
